class AppData {
  constructor() {
    this.content = "";
    this.metaData = {};
  }

  setContent(content) {
    this.content = content;
    return this;
  }

  getContent() {
    return this.content;
  }

  setMetaData(value, key) {
    if (key) this.metaData[key] = value;
    else this.metaData = value;
    return this;
  }

  getMetaData(key) {
    if (key) return (this.metaData || {})[key];
    return this.metaData;
  }
}

export { AppData };
